import axios, { endpoints } from 'src/utils/axios';

import { setSession } from './utils';
import { STORAGE_KEY } from './constant';

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }) => {
  try {
    const params = { email, password };

    const res = await axios.post(endpoints.auth.signIn, params);

    const { access_token, data } = res.data;

    if (!access_token) {
      throw new Error('Access token not found in response');
    }
    if (data?.email_verified_at !== null) {
      localStorage.setItem('user', JSON.stringify(data));
      setSession(access_token);
    }
    return res;
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Validate Referral Code
 *************************************** */
export const validateReferralFunc = async ({ referral_code }) => {
  const params = { referral_code };

  try {
    const res = await axios.post(endpoints.auth.validateReferral, params);
    return res; // res.data me success/message aayega
  } catch (error) {
    console.error('Error during referral validation:', error);
    throw error;
  }
};

/** **************************************
 * Save Referral (after verify)
 *************************************** */
export const saveReferral = async ({ referral_code }) => {
  const params = { referral_code };

  try {
    const res = await axios.post(endpoints.auth.saveReferral, params);
    return res;
  } catch (error) {
    console.error('Error during save referral:', error);
    throw error;
  }
};

/** **************************************
 * Mark First Visit (modal dismiss)
 *************************************** */
export const markFirstVisit = async () => {
  try {
    const res = await axios.post(endpoints.auth.markFirstVisit);
    return res;
  } catch (error) {
    console.error('Error during mark first visit:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({
  email,
  password,
  first_name,
  last_name,
  password_confirmation,
  role_id,
  gym_name,
  referral_code,
}) => {
  const params = {
    email,
    password,
    first_name,
    last_name,
    password_confirmation,
    gym_name,
    role_id,
    ...(referral_code && { referral_code }),
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    return res;
    // const { accessToken } = res.data;

    // if (!accessToken) {
    //   throw new Error('Access token not found in response');
    // }

    //   sessionStorage.setItem(STORAGE_KEY, accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Verify Email
 *************************************** */

export const VerifyEmail = async ({ email, otp, access_token, user, is_signup }) => {
  const params = {
    email,
    otp,
    ...(is_signup && { is_signup }),
  };

  try {
    const res = await axios.post(endpoints.auth.verify, params);

    localStorage.setItem('user', JSON.stringify(user));
    setSession(access_token);
    return res;
  } catch (error) {
    console.error('Error during verify email:', error);
    throw error;
  }
};

/** **************************************
 * Verify forget email
 *************************************** */

export const VerifyForgetEmail = async ({ email, otp }) => {
  const params = {
    email,
    otp,
  };

  try {
    const res = await axios.post(endpoints.auth.forgetVerify, params);

    return res;
  } catch (error) {
    console.error('Error during verify email:', error);
    throw error;
  }
};

/** **************************************
 * Resend OTP
 *************************************** */

export const ResendOtp = async ({ email, type }) => {
  const params = {
    email,
    type,
  };

  try {
    const res = await axios.post(endpoints.auth.resend_otp, params);
    return res?.data;
  } catch (error) {
    console.error('Error During resend:', error);
    throw error;
  }
};

/** **************************************
 * Forget Password
 *************************************** */

export const SendForgetPassword = async ({ email }) => {
  const params = {
    email,
  };

  try {
    const res = await axios.post(endpoints.auth.sendForget, params);

    return res;
  } catch (error) {
    console.error('Error during verify email:', error);
    throw error;
  }
};

/** **************************************
 * Update Forget Password
 *************************************** */

export const UpdateForgetPassword = async ({ email, password, password_confirmation }) => {
  const params = {
    email,
    password,
    password_confirmation,
  };

  try {
    const res = await axios.post(endpoints.auth.updateForgetPassword, params);

    return res;
  } catch (error) {
    console.error('Error during verify email:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    // 👇 Ye lines ensure karein ke mojood hain
    localStorage.removeItem('flow_just_signed_up');
    localStorage.removeItem('flow_signed_up_with_referral');

    sessionStorage.removeItem('just_signed_up');
    sessionStorage.removeItem('signed_up_with_referral');
    sessionStorage.removeItem('referral_welcome');

    // 👇 stale tab selection reset
    localStorage.removeItem('account_view_tab');
    localStorage.removeItem('referral_discount_referrer');
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
